import React, { useState, useEffect } from "react";
import "./Consultation.css";
import "./ConsultationMobile.css";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Transition1Animation from "./Transition1Animation";
import Transition2Animation from "./Transition2Animation";
import Transition3Animation from "./Transition3Animation";
import Transition4Animation from "./Transition4Animation";
import Transition5Animation from "./Transition5Animation";
import Transition6Animation from "./Transition6Animation";
import Transition7Animation from "./Transition7Animation";
import Transition8Animation from "./Transition8Animation";

const usStates = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

const canadianProvinces = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Nova Scotia",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
];

const questions = [
  {
    category: "Relationship Dynamic",
    items: [
      { id: 1, question: "How long have you been married?", type: "select",
        options: [
          "Less than a year",
          "1 to 4 years",
          "5 to 9 years",
          "10+ years"
        ] },
      { id: 2, question: "Are you and your spouse in agreement about the divorce?", type: "select", options: ["Yes", "No"] },
      { id: 3, question: "How would you describe your relationship dynamic right now?", type: "select", options: ["Amicable", "Distant", "Neutral", "Tense", "Highly Conflictual"] },
      { id: 4, question: "What is the reason for divorce?", type: "select-multiple", 
        options: [
          "Irreconcilable differences",
          "Lack of commitment",
          "Infidelity",
          "Excessive conflict and arguing",
          "Financial problems",
          "Lack of family support",
          "Incompatibility",
          "Abuse",
          "Complex reasons",
        ] },
    ],
  }, 
  {
    category: "Legal Guidance",
    items: [
      { id: 5,
        question: "Do you anticipate needing financial support (e.g., alimony)?",
        type: "select",
        options: ["Yes", "No", "Not sure"]
      },
      { id: 6,
        question: "Do you and your spouse agree on key aspects of the divorce?",
        type: "select",
        options: ["Yes", "No", "Not sure"]
      }, 
      {
        id: 7,
        question: "How complex is your situation?",
        type: "select",
        options: [
          "Simple (few shared assets, no disputes, no custody issues)",
          "Moderate (some shared assets, minor disputes)",
          "Complex (high-value assets, financial support required)"
        ]
      },
      {
        id: 8,
        question: "Are there any urgent legal concerns?",
        type: "select-multiple",
        options: [
          "Financial control issues",
          "Access to joint accounts",
          "Disputes over shared property",
          "Restraining orders",
          "Safety concerns",
          "None"
        ]
      },
    ]
  },
  {
    category: "Shared Responsibilities",
    items: [
      { id: 9, question: "Do you have children under 18?", type: "select", options: ["Yes", "No"] },
      { id: 10, question: "Do you have pets?", type: "select", options: ["Yes", "No"] },
    ]
  },
  {
    category: "Financial Guidance",
    items: [
      { id: 11, question: "What major assets do you and your spouse share?", type: "select-multiple", 
        options: [
          "Primary residence/home",
          "Vehicles",
          "Savings account",
          "Retirement funds",
          "Investments",
          "Properties",
          "None"
        ] },
      { id: 12, question: "What shared debts do you and your spouse have?", type: "select-multiple", 
        options: [
          "Credit card debt",
          "Mortgage",
          "Car loans",
          "Personal loans",
          "Medical bills",
          "None"
        ] },
    ]
  }, 
  {
    category: "Additional Information",
    items: [
        { 
          id: 13, question: "Provide details to help us personalize your guide (optional).", type: "text", skippable: true
        },
    ]
  },
  {
    category: "Email",
    items: [
      { id: 14, question: "Enter your email to get your personalized divorce guide!", type: "email" }
    ]
  },
];


const roadmapSteps = [
  "Step-by-step legal procedures",
  "Estimated timelines",
  "Asset and debt division",
  "Cost breakdowns & finances",
  "Logistical arrangements",
  "Emotional guidance",
];

const Consultation = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false); // For category transitions
  const [currentCategory, setCurrentCategory] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [isEmailValid, setIsEmailValid] = React.useState(false);
  const [email, setEmail] = useState('');
  const [answers, setAnswers] = useState({});
  const location = useLocation();
  const { name, country, region } = location.state || {};  

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000); // 3-second delay for loading screen
    return () => clearTimeout(timer);
  }, []);

  

  const totalQuestions = questions.reduce((acc, category) => acc + category.items.length, 0);
const completedQuestions =
  questions.slice(0, currentCategory).reduce((acc, category) => acc + category.items.length, 0) +
  currentQuestion + 1;

const progressPercentage = (completedQuestions / totalQuestions) * 100;

const handleNext = async () => {
  const currentAnswer = answers[current.id]; // Get the answer for the current question

    if (currentQuestion < questions[currentCategory].items.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else if (currentCategory < questions.length - 1 && currentCategory != 4) {
      // Show transition screen
      setIsTransitioning(true);

      if (currentCategory === 3) {
        setTimeout(() => {
          setIsTransitioning(false); // Hide transition screen after delay
          setCurrentCategory(currentCategory + 1); // Move to next category
          setCurrentQuestion(0); // Reset to first question of the new category
        }, 3000); // 3-second delay for transition screen
      } else {
        setIsTransitioning(false); // Hide transition screen after delay
        setCurrentCategory(currentCategory + 1); // Move to next category
        setCurrentQuestion(0); // Reset to first question of the new category
      }
    } 
    else if (currentCategory === 4) {
      setIsTransitioning(true);

      setTimeout(() => {
        setIsTransitioning(false); // Hide transition screen after delay
        setCurrentCategory(currentCategory + 1); // Move to next category
        setCurrentQuestion(0); // Reset to first question of the new category
      }, 10000); // 3-second delay for transition screen
    } else {
      setIsTransitioning(true);

      setTimeout(() => {
        setIsTransitioning(false);
        submitConsultation(answers);
      }, 3000); // 3-second delay for transition screen
    }

};

const handleBack = () => {
  if (currentQuestion > 0) {
    setCurrentQuestion(currentQuestion - 1);
  } else if (currentCategory > 0) {
    setCurrentCategory(currentCategory - 1);
    setCurrentQuestion(
      questions[currentCategory - 1].items.length - 1
    ); // Go to the last question of the previous category
  }
};


const handleAnswer = (answer) => {
  setAnswers({
    ...answers,
    [questions[currentCategory].items[currentQuestion].id]: answer,
    general: {
      name: name || "",  // Defaults to an empty string if undefined
      country: country || "",
      region: region || "",
    },
  });
};

  const current = questions[currentCategory].items[currentQuestion];
  

  const submitConsultation = async (answers) => {
    try {
  
      const response = await axios.post(
        "https://us-central1-divori-ai.cloudfunctions.net/api/submit",
        { answers }, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Ensure proper content type
          },
          withCredentials: true, // Include credentials
        }
      );
  
      if (response.status === 200) {
        window.location.href = "https://buy.stripe.com/eVa6pvbWigSe9Fe3ci";
      } else {
        console.error("Error:", response.statusText);
        alert("An error occurred. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to submit the consultation. Please check your connection.");
    }
  };

  return (
    <div className="=wr">
    <div className="consultation">
      <div className="header-banner">
      Divori: Your AI Divorce Consultant
    </div>
      {isLoading ? (
        <div className="loading-screen">
      <Transition1Animation/>

          <h1 className="hidden delayed-animation-1">
            Let's get started.
          </h1>
        </div>
      ) : isTransitioning ? (
        <div className="loading-screen">
          

        {currentCategory === 3 && (
            <>
                  <Transition5Animation/>
              <h1 className="hidden delayed-animation-1">
              Remember that you are not alone in this!
              </h1>
              
              <p className="hidden delayed-animation-3">
              Many have gone through divorce successfully, and so will you. Together, we’ll break it down step-by-step so you can make confident decisions for your future.
              </p>
            </>
          )}

          {currentCategory === 4 && (
            <div className="roadmap-steps-container">
            {/* Loading Video */}
            <Transition7Animation/>
          
            {/* Glowy Title */}
            
            <h1 className="fade-in">Creating Your Personalized Divorce Guide</h1>
          
            {/* Roadmap Steps */}
            <ul className="roadmap-steps">
              {roadmapSteps.map((step, index) => (
                <li key={index} className={`hidden delay-${index + 1}s`}>
                  <span className="checkmark">
                    <i className="fas fa-check"></i>
                  </span>
                  <span className="roadmap-text">{step}</span>
                </li>
              ))}
            {/* Glowy Final Message */}
            <p className="ready hidden delay-8s">Your Personalized Divorce Guide is Ready!</p>
            </ul>
          </div>
          
          )}

        </div>
      ) :
        (
        <div className="question-section">
          <header className="question-header">
            <p>
              Question {currentQuestion + 1} of {questions[currentCategory].items.length} in {questions[currentCategory].category}
            </p>
            <div className="progress-bar">
              <div
                className="progress"
                style={{
                  width: `${progressPercentage}%`,
                }}
              ></div>
            </div>
          </header>

          

          <main className="question-container">
            <h1>{current.question}</h1>
          
          {current.type === "email" ? (
            <div className="email-input">
              <input
                type="email"
                className="email-box"
                placeholder="Enter your email"
                value={answers[current.id] || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  handleAnswer(value);
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); // Basic email validation regex
                  setIsEmailValid(isValidEmail); // Update state for email validity
                  if (!isValidEmail && value) {
                    document.getElementById(`error-${current.id}`).style.display = "block";
                  } else {
                    document.getElementById(`error-${current.id}`).style.display = "none";
                  }
                }}
              />
              <p id={`error-${current.id}`} className="error-message" style={{ display: "none" }}>
                * Please enter a valid email address.
              </p>
            </div>
          ) : (
            ""
          )}

            {current.type === "select" ? (
              <div className="options">
                {current.options.map((option, index) => (
                  <button
                    key={index}
                    className={`option-button ${
                      answers[current.id] === option ? "selected" : ""
                    }`}
                    onClick={() => handleAnswer(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>
            ) : ""}

            {current.type === "text" ? (
                <textarea
                  className="text-area"
                  rows="4"
                  placeholder="e.g., Wanting to avoid court, shared debts, child custody"
                  value={answers[current.id] || ""}
                  onChange={(e) => handleAnswer(e.target.value)}
                ></textarea>
            ) : ""}

            {current.type === "select-multiple" ? (
              <div className="options-multiple">
                {current.options.map((option, index) => (
                  <button
                    key={index}
                    className={`option-button-multiple ${
                      answers[current.id]?.includes(option) ? "selected" : ""
                    }`}
                    onClick={() => {
                      const selectedOptions = answers[current.id] || [];

                      if (option === "None") {
                        // If "None" is selected, clear all other options and select only "None"
                        handleAnswer(selectedOptions.includes("None") ? [] : ["None"]);
                      } else {
                        // If any other option is selected while "None" is selected, deselect "None"
                        if (selectedOptions.includes("None")) {
                          handleAnswer([option]);
                        } else if (selectedOptions.includes(option)) {
                          // Remove the selected option
                          handleAnswer(selectedOptions.filter((item) => item !== option));
                        } else {
                          // Add the selected option
                          handleAnswer([...selectedOptions, option]);
                        }
                      }
                    }}
                  >
                    {option}
                  </button>
                ))}
              </div>
            ) : (
              ""
            )}

          </main>

          <footer className="question-footer">
          <button
            className="next-button"
            onClick={handleBack}
            disabled={currentCategory === 0 && currentQuestion === 0} // Disable on the first question
          >
            Back
          </button>
            <button
              className="next-button"
              onClick={handleNext}
              disabled={!answers[current.id] && !questions[currentCategory].items[currentQuestion].skippable  || 
                (current.type === "email" && !isEmailValid) }
            >
              {currentCategory === questions.length - 1 &&
              currentQuestion === questions[questions.length - 1].items.length - 1
                ? "Next"
                : "Next"}
            </button>
          </footer>
        </div>
      )}
    </div>
  </div>
    
  );
};


export default Consultation;
